<template>
    <div>
        <b-card :style="{'max-width': '2000px', 'width': '1024px', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
            <b-card-text>
                <h4>Create Deliveries</h4>
            </b-card-text>

            <b-card-text>
                Delivery Date(s): 
                <flat-pickr v-model="date_range" :config="{ dateFormat: 'm-d-Y', mode: 'range' }" style="padding: 7px; font-size: 14px; text-align: center; border: 1px solid gray; width: 300px;"></flat-pickr>

                <b-button size="md" variant="success" style="display: inline-block;" @click="fetch_init">Search</b-button>
            </b-card-text>

            <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                <div v-if="items.length > 0" style="margin-top: 10px;">

                    <table class="text-monospace" style="width: 100%; margin-top: 10px;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr">
                                    #
                                </td>
                                <td class="ipt_tdhr">
                                    DELVRY DATE
                                </td>
                                <td class="ipt_tdhr">
                                    INV ID
                                </td>
                                <td class="ipt_tdhr">
                                    SKU
                                </td>
                                <td class="ipt_tdhr">
                                    QTY
                                </td>
                                <td class="ipt_tdhr">
                                    CUSTOMER
                                </td>
                                <td class="ipt_tdhr">
                                    STATUS
                                </td>
                                <td class="ipt_tdhr" style="width: 120px;">
                                    TRUCK / DRIVER
                                </td>
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item,idx in items" v-bind:key="idx">
                                <td class="ipt_tdhr non-header">
                                    {{ idx + 1 }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.request_date }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.invoice_id }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.item.product_sku }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ item.item.quantity }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    <div v-if="item.item.order_type == 'store_pickup'">
                                        {{packet.locationsdict[item.location_id]}}
                                    </div>
                                    <div v-else>
                                        <div>
                                            {{ item.customer.address_line_1 }}
                                        </div>
                                        <div>
                                            {{ item.customer.address_line_2 }}, {{ item.customer.zipcode }}, {{ item.customer.state }}
                                        </div>
                                    </div>
                                </td>
                                <td class="ipt_tdhr non-header">
                                    {{ items_state_dict[item.item.state] }}
                                </td>
                                <td class="ipt_tdhr non-header">
                                    <b-form-select size="sm" :options="packet.trucks" v-model="item.truck"></b-form-select style="font-size: 12px;">
                                </td>
                                <td class="ipt_tdhr non-header">
                                    <div v-if="item.item.state == 'atdl'">
                                        <b-button size="sm" variant="warning" :disabled="true">ADDED</b-button>
                                    </div>
                                    <div v-else>
                                        <b-button size="sm" variant="primary" @click="add_to_delivery_list(item)">ADD</b-button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>      
                </div>
                <div v-else>
                    <b-alert show variant="warning">No records</b-alert>
                </div>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"

    export default {
        name: "AdminToolsCreateDeliveries",
        components: {Backer, flatPickr},
        data: function() {
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                date_range: null,
                picked_date_range: null,
                items_state_dict: {
                    "rts": "READY TO SHIP",
                    "raw": "RCVD AT WRHS",
                    "picked": "PICKED",
                    "atdl": "ADDED",
                    "delivered": "DELIVERED"
                }
            }
        },
        methods: {
            set_dates: function(value) {
                let start = null;
                let end = null;

                if(value == 'today'){
                    start = moment().format("MM-DD-YYYY")
                    end = moment().format("MM-DD-YYYY")
                }
                if(value == 'yesterday'){
                    start = moment().add(-1, 'days').format("MM-DD-YYYY")
                    end = moment().add(-1, 'days').format("MM-DD-YYYY")
                }
                if(value == 'this_week'){
                    start = moment().startOf('week').format("MM-DD-YYYY")
                    end = moment().endOf('week').format("MM-DD-YYYY")
                }
                if(value == 'last_week'){
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY")
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY")
                }
                if(value == 'this_month'){
                    start = moment().startOf('month').format("MM-DD-YYYY")
                    end = moment().endOf('month').format("MM-DD-YYYY")
                }
                if(value == 'last_month'){
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY")
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY")
                }
                if (start && end) {
                    this.date_range = (start + ' to ' + end)
                    this.picked_date_range = value;
                }
            },
            fetch_init: function() {
                let dates = this.date_range.split(" to ");
                // let location_id = this.packet.userDetails.properties.location_id;
                // if (this.packet.userDetails.userrole == 'admin'){
                //     location_id = null
                // }
                let that = this;
                let data = {dates: dates}
                let path = "/api/transfers/get_items_for_deliveries/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            add_to_delivery_list: function(item){
                let that = this;
                let data = {invoice_id: item.invoice_id, product_sku: item.item.product_sku}
                let path = "/api/transfers/set_item_state_to_atdl/"
                let s = function(response) {
                    if (response.data.result){
                        item.item.state = "atdl";
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        }
    }
</script>

<style scoped>
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsCreateDeliveries.vue